import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Engine } from '@/types/enums/room.enum'
/**
 * import component
 */
import BrowserSupportPopup from '@/components/checkup/BrowserSupportPopup.vue'
import DeviceAlertPopup from '@/components/checkup/DeviceAlertPopup.vue'
import Joining from '@/components/room/Joining.vue'
import PreviewBeforeJoin from '@/components/room/PreviewBeforeJoin.vue'

/**
 * Import composables & store
 */
import { computed, defineAsyncComponent, onBeforeUnmount, onMounted, ref } from 'vue'
import useRoomByEngine from '@/composables/room/useRoomByEngine'
import { useDeviceStore, useRoomStore } from '@/stores'
import useSocketEvent from '@/composables/room/useSocketEvent'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Room',
  setup(__props) {

/**
 * Import types
 */
const TwilioRoom = defineAsyncComponent(() => import('@/components/room/twilio/TwilioRoom.vue'))
const ZoomRoom = defineAsyncComponent(() => import('@/components/room/zoom/ZoomNewRoom.vue'))
const EmbedRoom = defineAsyncComponent(() => import('@/components/room/embed/EmbedRoom.vue'))

const device = useDeviceStore()

const route = useRoute()

const isJoinRoom = ref<boolean>(false)
const isJoining = ref<boolean>(false)
const { socket } = useSocketEvent()
const {
  // Ref
  isOpenPopup,
  roomProps,

  // Methods
  addParticipantInRoom,
  joinRoom,
  onEngineDisconnect,
  onParticipantConnect,
  onParticipantDisconnect,
  onParticipantShareScreen,
  addFocusCompartment,
  popoutCompartment,
} = useRoomByEngine()

const roomStore = useRoomStore()
/**
 * Computed
 */
const roomComponent = computed(() => {
  if (roomStore.currentEngine === Engine.TWILIO) return TwilioRoom
  else if (roomStore.currentEngine === Engine.ZOOM) return ZoomRoom
  else if ([Engine.WHEREBY, Engine.VICOLLO].includes(roomStore.currentEngine)) return EmbedRoom
  else return undefined
})

const canJoinRoom = computed(() => {
  if (roomStore.currentEngine === Engine.ZOOM) return true
  else return true
})

/**
 * Methods
 */
const participantClickJoinRoom = async () => {
  isJoinRoom.value = true
  isJoining.value = true
  device.setStateEnableToLocal()
  await joinRoom()
  isJoining.value = false
}
const connectRoom = (requestTest?: boolean) => {
  roomStore.requestTestDiagnostic = !!requestTest
  participantClickJoinRoom()
}

// TODO: old version use twilio and new use zoom
const switchDevices = (isRepublish: boolean) => {
  window.location.reload()
}

onMounted(() => {
  if ('whereby' in route.query) {
    roomStore.forceUseEngine = true
    roomStore.setCurrentEngine(Engine.WHEREBY)
  }
})

onBeforeUnmount(() => {
  socket.disconnect()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DeviceAlertPopup, {
      modelValue: _unref(isOpenPopup),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isOpenPopup) ? (isOpenPopup).value = $event : null)),
      content: _unref(device).permissionError?.message || 'Some device changed please republish again',
      "is-republish": isJoinRoom.value || _unref(device).someDeviceIsGone,
      onRepublish: _cache[1] || (_cache[1] = ($event: any) => (switchDevices(true)))
    }, null, 8, ["modelValue", "content", "is-republish"]),
    (_unref(roomStore).room?.currentEngine)
      ? (_openBlock(), _createBlock(BrowserSupportPopup, {
          key: 0,
          engine: _unref(roomStore).room?.currentEngine
        }, null, 8, ["engine"]))
      : _createCommentVNode("", true),
    (isJoinRoom.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(Joining, { "is-joining": isJoining.value }, null, 8, ["is-joining"]),
          (roomComponent.value && !isJoining.value && _unref(roomStore).room.id && _unref(roomStore).localParticipantInfo)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(roomComponent.value), _mergeProps({ key: 0 }, _unref(roomProps), {
                onOnParticipantConnect: _unref(onParticipantConnect),
                onOnParticipantDisconnect: _unref(onParticipantDisconnect),
                onOnParticipantShareScreen: _unref(onParticipantShareScreen),
                onOnEngineDisconnect: _unref(onEngineDisconnect),
                onOnSubsribeParticipantInRoom: _unref(addParticipantInRoom),
                onOnFocusParticipant: _unref(addFocusCompartment),
                onOnPopoutParticipant: _unref(popoutCompartment)
              }), null, 16, ["onOnParticipantConnect", "onOnParticipantDisconnect", "onOnParticipantShareScreen", "onOnEngineDisconnect", "onOnSubsribeParticipantInRoom", "onOnFocusParticipant", "onOnPopoutParticipant"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(PreviewBeforeJoin, {
          key: 2,
          "can-join-room": canJoinRoom.value,
          onJoinRoom: connectRoom,
          onTestRoom: _cache[2] || (_cache[2] = ($event: any) => (connectRoom(true)))
        }, null, 8, ["can-join-room"]))
  ], 64))
}
}

})